import { useAppContext } from '../../context/AppContext';
import { useHunts } from '../../hooks/useHunts';
import { comparatorFor, formatLabel, isValidItemKey } from '../../lib/huntDomain';
import styles from './HuntListView.module.css';

export default function HuntListView() {
  const { dispatch, derived, activeHunt } = useAppContext();
  const { updateHuntList } = useHunts();
  const { capturedItems, primaryByItem } = derived;

  if (!activeHunt) return null;

  const huntList = activeHunt.huntList ?? [];

  const rows = [...huntList].sort(comparatorFor(activeHunt.type)).map(key => {
    const captured = capturedItems.has(key);
    const primary = captured ? primaryByItem.get(key) : null;
    return {
      itemKey: key,
      captured,
      note: captured ? (primary?.location ?? '—') : 'Not captured yet',
      meta: primary ? new Date(primary.addedAt).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' }) : null,
    };
  });

  function openDetail(itemKey, captured) {
    dispatch({
      type: 'OPEN_MODAL',
      modal: captured ? 'detail' : 'addPhoto',
      data: { itemKey },
    });
  }

  async function removeFromHunt(itemKey) {
    await updateHuntList(activeHunt, huntList.filter(k => k !== itemKey));
  }

  async function addItemToHunt() {
    const label = activeHunt.type === 'numbers' ? 'a number (1-100)' : 'a letter (A-Z)';
    const raw = window.prompt(`Add which ${label} to the hunt list?`);
    if (raw == null) return;
    const key = activeHunt.type === 'alphabet' ? raw.trim().toUpperCase() : raw.trim();
    if (!isValidItemKey(activeHunt.type, key)) return;
    if (!huntList.includes(key)) {
      await updateHuntList(activeHunt, [...huntList, key]);
    }
  }

  return (
    <div className={styles.view}>
      <div className={styles.page}>
        <h2 className={styles.pageTitle}>Hunt List</h2>

        {rows.length === 0 ? (
          <p className={styles.empty}>Nothing on the hunt list yet.</p>
        ) : (
          <div className={styles.list}>
            {rows.map(({ itemKey, captured, note, meta }) => (
              <div key={itemKey} className={styles.row}>
                <button
                  className={styles.numChip}
                  onClick={() => openDetail(itemKey, captured)}
                >
                  {formatLabel(activeHunt.type, itemKey)}
                </button>
                <span className={styles.noteBlock}>
                  <span className={styles.note}>{note}</span>
                  {meta && <span className={styles.meta}>{meta}</span>}
                </span>
                <button
                  className={styles.tag}
                  onClick={() => removeFromHunt(itemKey)}
                  title="Remove from hunt list"
                >
                  HUNT
                </button>
              </div>
            ))}
          </div>
        )}

        <button className={styles.addBtn} onClick={addItemToHunt}>
          + ADD TO HUNT LIST
        </button>
      </div>
    </div>
  );
}
